<style lang="scss" scoped>
.module2 {
  .slide-2 {
    background-image: url(../../../assets/module2/slide2/background-01.jpg);
    background-size: cover;
    background-position: center;
    h1 {
      font-size: 140px;
      color: #3b7fc2;
      transform-origin: 100% 0%;
      transform: rotate(-3deg);
    }
    .title-wrap {
      left: 0;
      top: 60px;
      position: absolute;
      display: inline-block;
      right: unset;
    }
    p {
      font-size: 32px;
      line-height: 1.4;
    }
    .content {
      max-width: 940px;
      position: relative;
      right: unset;
      top: 277px;
      color: #fff;
    }
    .right-text {
      margin-top: 50px;
      text-align: right;
    }
    h1 {
      color: #fff;
      font-size: 130px;
      width: 100%;
      margin-top: -40px;
      margin-left: 2.5rem;

      span {
        color: #e30613;
        transform: rotate(3deg);
        display: inline-block;
        font-size: 1.4em;
        vertical-align: sub;
      }
    }
    h3 {
      margin-top: 0px;
      color: #c5d43b;
      font-size: 40px;
      margin-left: 5%;
    }
    .page {
      padding-top: 20%;
    }
    .page p {
      margin-bottom: 30px;
    }
    .ambo {
      color: #e30613;
      display: inline;
      font-size: 50px;
      font-family: "Kookycat-FASTcaps";
      font-weight: 100;
    }
    .content4 {
      width: 60%;
    }
  }
}
</style>

<template>
  <div class="slide-2">
    <transition name="scale" appear>
      <div class="title-wrap" v-show="slideIndex == 1">
        <h3>{{ $t("module2.slide2.heading1") }}</h3>
        <h3>{{ $t("module2.slide2.heading2") }}</h3>
        <h1>
          {{ $t("module2.slide2.heading3") }} <span class="number">107</span>
        </h1>
      </div>
    </transition>
    <div class="pages">
      <div class="page page-left">
        <transition name="fadeLeft" appear>
          <p
            class="delay-3"
            v-show="slideIndex == 1"
            v-html="$t('module2.slide2.content1')"
          ></p>
        </transition>
        <transition name="fadeLeft" appear>
          <p class="delay-3" v-show="slideIndex == 1">
            {{ $t("module2.slide2.content2") }}
            <span class="ambo">{{ $t("module2.slide2.content5") }} </span>
          </p>
        </transition>
      </div>

      <div class="page page-right">
        <transition name="fadeRight" appear>
          <p
            class="delay-3"
            v-show="slideIndex == 1"
            v-html="$t('module2.slide2.content3')"
          ></p>
        </transition>
        <transition name="fadeRight" appear>
          <div v-show="slideIndex == 1" class="delay-4 content4">
            <p>{{ $t("module2.slide2.content4") }}</p>
          </div>
        </transition>
      </div>
    </div>
    <transition name="fadeLeft" appear>
      <img
        v-show="slideIndex == 1"
        src="@/assets/module2/slide2/images-01.png"
        class="chars delay-6"
      />
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
